// extracted by css-extract-rspack-plugin
export default {"cls1":"CourseResults-cls1_9tZ","cls2":"CourseResults-cls2_hRs CourseResults-cls1_9tZ"};